module.exports = __webpack_public_path__ + "static/img/logo_dark.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_dark.png
// module id = fS3R
// module chunks = 0